import React, { useEffect } from 'react';
import ContactForm from './ContactForm';
import "./Contact.css";

function Contact() {

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="contact-wrapper">
      <br />
      <div className="contact-container">
        {/* Row */}
        <div className="contact-row">
          {/* Left Column - Text Section */}
          <div className="contact-column contact-left-column">
            <h2>Get in Touch</h2>
            <p>
              I’d love to hear from you! Whether you have a question, want to
              collaborate on a project, or just want to say hi, feel free to reach
              out using the form beside.
            </p>
            <p>
              You can also contact me directly at 
              <a href="mailto:piyushagarwalplay@gmail.com"> piyushagarwalplay@gmail.com</a>.
            </p>
          </div>

          {/* Right Column - Contact Form */}
          <div className="contact-column contact-right-column">
            <ContactForm />
          </div>
        </div>
      </div>
      <br />
    </div>
  );
}

export default Contact;
